import React from 'react';
function AccountID() {
  return (
    <svg width='18' height='16' viewBox='0 0 18 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.6843 8.75209C14.8397 8.3298 13.8456 8.3298 13.001 8.75209L11.8427 9.33127V12.1188C11.8427 12.8729 12.7324 13.731 14.3427 14.7479C15.9529 13.731 16.8427 13.0813 16.8427 12.1188C16.8427 11.1563 16.8427 9.33127 16.8427 9.33127L15.6843 8.75209Z'
        fill='white'
      />
      <path
        d='M4.44074 5.75205H4.55743M9 5.75205H9.11669M13.4412 5.75205H13.5579M8.5 10.252H2.77778C1.79594 10.252 1 9.45611 1 8.47427V3.02982C1 2.04798 1.79594 1.25204 2.77778 1.25204H15.2222C16.2041 1.25204 17 2.04798 17 3.02982V5.75205M11.8427 9.33127L13.001 8.75209C13.8456 8.3298 14.8397 8.3298 15.6843 8.75209L16.8427 9.33127C16.8427 9.33127 16.8427 11.1563 16.8427 12.1188C16.8427 13.0813 15.9529 13.731 14.3427 14.7479C12.7324 13.731 11.8427 12.8729 11.8427 12.1188V9.33127Z'
        stroke='#7F7D83'
        stroke-width='1.6'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default AccountID;
